import { inject } from 'aurelia';

import { ApiService } from './api-service';
import { websiteShortCode } from '../environment';

@inject(ApiService)
export class BlogAuthorService {
    path = 'BlogAuthor';
    shortCode: string = websiteShortCode() ?? 'CG';
    constructor(private api: ApiService) { }

    async getByAlias(alias) {
        return await this.api.doGet(`${this.path}/ByAlias/${alias}`);
    }

    async getByWebsiteCode() {
        return await this.api.doGet(`${this.path}/ByWebsiteCode/${this.shortCode}`);
    }
}
